module.exports = __webpack_public_path__ + "static/media/icon-personal.fa49e78e.svg";